(function () {
  var root = document.getElementById('sp-root');
  if (!root) return;

  var EDGE_URL = root.dataset.edgeFnUrl || '';
  var SHOP_URL = root.dataset.shopUrl || '';
  var HEADING = root.dataset.heading || 'Seller Portal';
  var SUBHEADING = root.dataset.subheading || 'Submit and manage your consignment items';
  var LAYOUT = root.dataset.layout || 'stacked';
  var SECTION_WIDTH = root.dataset.sectionWidth || 'default';
  var SUBMIT_HEADING = root.dataset.submitHeading || 'Ready to sell?';
  var SUBMIT_DESCRIPTION = root.dataset.submitDescription || 'List your figure skating gear in minutes. We handle the rest.';
  var CUSTOMER_EMAIL = root.dataset.customerEmail || '';
  var CUSTOMER_NAME = root.dataset.customerName || '';
  var LOGIN_URL = root.dataset.loginUrl || '/account/login';
  var CUSTOMER_ID = root.dataset.customerId || '';
  var CUSTOMER_PHONE = root.dataset.customerPhone || '';
  var KLAVIYO_LIST_ID = root.dataset.klaviyoList || '';
  var COMMISSION_PCT = parseFloat(root.dataset.commission) || 30;
  var PROCESSING_PCT = parseFloat(root.dataset.processing) || 2.9;
  var COMMISSION_RATE = COMMISSION_PCT / 100;
  var PROCESSING_RATE = PROCESSING_PCT / 100;
  var MAX_PENDING_LISTINGS = 5;

  var CATEGORIES = [
    { value: 'dresses', label: 'Dresses', icon: '\uD83D\uDC57' },
    { value: 'apparel', label: 'Apparel', icon: '\uD83D\uDC55' },
    { value: 'skate_sets', label: 'Skate Sets', icon: '\u26F8\uFE0F' },
    { value: 'boots', label: 'Boots', icon: '\uD83D\uDC62' },
    { value: 'blades', label: 'Blades', icon: '\u26F8\uFE0F' },
    { value: 'accessories', label: 'Accessories', icon: '\uD83D\uDC8E' },
    { value: 'bags', label: 'Bags', icon: '\uD83D\uDC5C' },
    { value: 'other', label: 'Other', icon: '\uD83D\uDCE6' }
  ];
  var CONDITIONS = [
    { value: 'like_new', label: 'Like New', icon: '\u2728', desc: 'Worn 1\u20132 times, no visible wear' },
    { value: 'gently_used', label: 'Gently Used', icon: '\uD83D\uDC4C', desc: 'Light wear, excellent shape' },
    { value: 'good', label: 'Good', icon: '\uD83D\uDC4D', desc: 'Normal wear, fully functional' },
    { value: 'fair', label: 'Fair', icon: '\uD83D\uDD27', desc: 'Visible wear or minor flaws' }
  ];
  var TERMS_HTML = '<p><strong>1. OWNERSHIP &amp; AUTHORIZATION</strong><br>You represent and warrant that you are the legal owner of the item(s) submitted and have full authority to consign them for sale.</p>'
    + '<p><strong>2. ITEM CONDITION</strong><br>Items are sold "as is" based on your description and photos. You agree to accurately and honestly describe the condition of all items. AST reserves the right to reject or reclassify items that do not match their described condition.</p>'
    + '<p><strong>3. COMMISSION &amp; FEES</strong><br>AST retains a ' + COMMISSION_PCT + '% commission on the final sale price plus a ' + PROCESSING_PCT + '% payment processing fee. Your payout is the sale price minus these fees.</p>'
    + '<p><strong>4. PRICING</strong><br>AST reserves the right to suggest price adjustments. The listing price set at submission may be modified with mutual agreement.</p>'
    + '<p><strong>5. SHIPPING</strong><br>Once your item sells, you are responsible for shipping it directly to the buyer at your own expense. You must purchase your own shipping label and ship within 5 business days of being notified of the sale. AST will provide you with the buyer\u2019s shipping address. We strongly recommend using a tracked and insured shipping method. AST is not responsible for items lost or damaged in transit.</p>'
    + '<p><strong>6. LISTING DURATION</strong><br>Items are listed for up to 90 days. After this period, AST may delist the item. Unsold items will be removed from the store.</p>'
    + '<p><strong>7. NO RETURNS OR REFUNDS ON CONSIGNED ITEMS</strong><br>All consignment sales are final. Consigned items are not eligible for returns, refunds, or exchanges by the buyer. By consigning, you acknowledge and agree that AST will not process chargebacks or refunds for your consigned item(s) after sale.</p>'
    + '<p><strong>8. LIABILITY LIMITATION</strong><br>AST acts solely as an intermediary between Seller and buyer. AST does not handle, store, or ship consigned items. AST is not liable for any claims, disputes, or damages arising from the sale of consigned items, including items lost or damaged during shipping.</p>'
    + '<p><strong>9. PAYOUTS</strong><br>Payouts are processed within 5\u20137 business days after the item sells via your chosen method (PayPal or Venmo). AST is not responsible for delays caused by third-party payment processors.</p>'
    + '<p><strong>10. WITHDRAWAL</strong><br>You may request to withdraw your listing before it sells by contacting us. The item will be delisted from the store.</p>';

  var state = {
    view: 'login',
    seller: null,
    listings: [],
    payouts: [],
    activeTab: 'listings',
    formStep: 0,
    formData: {},
    photos: [],
    loading: false,
    error: null,
    contactData: {},
    contactSuccess: false,
    contactError: null,
    editingListing: null,
    editFormData: {},
    submitOpen: false,
    listingsCollapsed: false,
    offers: []
  };

  // Auto-login if Shopify customer is logged in
  if (CUSTOMER_EMAIL) {
    state.loading = true;
    render();
    fetchSeller(CUSTOMER_EMAIL, true);
  } else {
    render();
  }

  var widthClass = 'sp-width--' + SECTION_WIDTH;

  /* ── Render ── */
  function render() {
    if (state.loading) {
      root.innerHTML = '<div class="sp-wrap ' + widthClass + '"><div class="sp-loading">Loading your dashboard...</div></div>';
      return;
    }
    if (state.view === 'login') renderLogin();
    else if (state.view === 'success') renderSuccess();
    else renderDashboard();
  }

  function renderDashboard() {
    if (LAYOUT === 'stacked') renderDashboardStacked();
    else renderDashboardTabbed();
  }

  function renderLogin() {
    var h = '<div class="sp-wrap ' + widthClass + '"><div class="sp-login">';
    h += '<h1>' + esc(HEADING) + '</h1>';
    h += '<p>' + esc(SUBHEADING) + '</p>';
    if (state.error) h += '<div class="sp-error">' + esc(state.error) + '</div>';
    h += '<p style="font-size:1.5rem;color:#666;margin-bottom:1.5rem;">Log in to your account to access the seller portal, submit items, and track your earnings.</p>';
    h += '<a href="' + LOGIN_URL + '" class="btn btn--primary" style="width:100%;text-align:center;display:block;">Log In to Your Account</a>';
    h += '<p class="sp-hint">Don\u2019t have an account? <a href="' + LOGIN_URL + '" style="color:#1a1a1a;text-decoration:underline;">Create one here</a> \u2014 it\u2019s free.</p>';
    h += '</div></div>';
    root.innerHTML = h;
  }

  /* ── Stacked Dashboard (new default) ── */
  function renderDashboardStacked() {
    var s = state.seller;
    var listings = state.listings;
    var payouts = state.payouts;
    var totalListings = listings.length;
    var active = listings.filter(function (l) { return l.status === 'live' || l.status === 'approved'; }).length;
    var totalEarned = payouts.filter(function (p) { return p.status === 'completed'; })
      .reduce(function (sum, p) { return sum + (p.seller_payout_cents || 0); }, 0);
    var pendingPayout = payouts.filter(function (p) { return p.status === 'pending'; })
      .reduce(function (sum, p) { return sum + (p.seller_payout_cents || 0); }, 0);

    var h = '<div class="sp-wrap ' + widthClass + '">';
    h += '<div class="sp-header"><div>';
    h += '<h1>Welcome back, ' + esc(s ? (s.name || s.email) : 'Seller') + '</h1>';
    h += '<div class="sp-greeting">Consignment Seller Portal</div>';
    h += '</div><span class="sp-logout" id="sp-logout">Sign out</span></div>';

    var pendingOffers = state.offers.length;
    h += '<div class="sp-cards">';
    h += mkCard(totalListings, '\uD83D\uDCE6 Total Listings');
    h += mkCard(active, '\u2728 Active');
    h += mkCard(fmt(totalEarned), '\uD83D\uDCB5 Total Earned', { cls: 'sp-card--green sp-card--click', attr: 'data-scroll-earnings' });
    h += mkCard(pendingPayout > 0 ? fmt(pendingPayout) : '$0.00', '\u23F3 Pending Payout', { cls: 'sp-card--green sp-card--click', attr: 'data-scroll-earnings' });
    h += mkCard(pendingOffers, '\uD83D\uDCE9 Pending Offers', { cls: (pendingOffers > 0 ? 'sp-card--orange ' : '') + 'sp-card--click', attr: 'data-scroll-offers' });
    h += '</div>';

    // Submit section
    var pendingCount = listings.filter(function (l) { return l.status === 'pending_review' || l.status === 'pending'; }).length;
    var atLimit = pendingCount >= MAX_PENDING_LISTINGS;
    h += '<div class="sp-stacked-section">';
    if (state.submitOpen) {
      h += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:1.5rem;">';
      h += '<h2 class="sp-stacked-heading" style="margin-bottom:0">Submit an Item</h2>';
      h += '<button class="sp-btn sp-btn-secondary" data-cancel-submit style="font-size:1.4rem;padding:0.6rem 1.4rem;">Cancel</button>';
      h += '</div>';
      h += renderFormTab();
    } else {
      h += '<div class="sp-submit-cta">';
      h += '<div class="sp-submit-cta-text">';
      h += '<h3>' + esc(SUBMIT_HEADING) + '</h3>';
      if (atLimit) {
        h += '<p style="color:#b91c1c;">You have ' + pendingCount + ' items pending review. Please wait for them to be reviewed before submitting more.</p>';
      } else {
        h += '<p>' + esc(SUBMIT_DESCRIPTION) + '</p>';
      }
      h += '</div>';
      if (!atLimit) {
        h += '<button class="sp-btn sp-btn-primary" data-open-submit>Submit an Item</button>';
      }
      h += '</div>';
    }
    h += '</div>';

    // My Listings section (collapsible)
    h += '<div class="sp-stacked-section">';
    h += '<button class="sp-collapse-toggle" data-toggle-listings>';
    h += 'My Listings (' + totalListings + ')';
    h += '<span class="sp-collapse-arrow' + (state.listingsCollapsed ? ' collapsed' : '') + '">\u25BC</span>';
    h += '</button>';
    if (!state.listingsCollapsed) {
      h += renderListingsTab();
    }
    h += '</div>';

    // Offers section
    if (state.offers.length > 0) {
      h += '<div class="sp-stacked-section" id="sp-offers-section">';
      h += '<h2 class="sp-stacked-heading">Offers (' + state.offers.length + ' pending)</h2>';
      h += renderOffersSection();
      h += '</div>';
    }

    // Earnings section
    h += '<div class="sp-stacked-section" id="sp-earnings-section">';
    h += '<h2 class="sp-stacked-heading">Earnings</h2>';
    h += renderEarningsTab();
    h += '</div>';

    h += '</div>';
    root.innerHTML = h;
    bindDashboard();
  }

  /* ── Tabbed Dashboard (classic) ── */
  function renderDashboardTabbed() {
    var s = state.seller;
    var listings = state.listings;
    var payouts = state.payouts;
    var totalListings = listings.length;
    var active = listings.filter(function (l) { return l.status === 'live' || l.status === 'approved'; }).length;
    var totalEarned = payouts.filter(function (p) { return p.status === 'completed'; })
      .reduce(function (sum, p) { return sum + (p.seller_payout_cents || 0); }, 0);
    var pendingPayout = payouts.filter(function (p) { return p.status === 'pending'; })
      .reduce(function (sum, p) { return sum + (p.seller_payout_cents || 0); }, 0);

    var h = '<div class="sp-wrap ' + widthClass + '">';
    h += '<div class="sp-header"><div>';
    h += '<h1>' + esc(s ? (s.name || s.email) : 'Seller') + '</h1>';
    h += '<div class="sp-welcome">Consignment Seller Portal</div>';
    h += '</div><span class="sp-logout" id="sp-logout">Sign out</span></div>';

    var pendingOffers = state.offers.length;
    h += '<div class="sp-cards">';
    h += mkCard(totalListings, '\uD83D\uDCE6 Total Listings');
    h += mkCard(active, '\u2728 Active');
    h += mkCard(fmt(totalEarned), '\uD83D\uDCB5 Total Earned', { cls: 'sp-card--green sp-card--click', attr: 'data-scroll-earnings' });
    h += mkCard(pendingPayout > 0 ? fmt(pendingPayout) : '$0.00', '\u23F3 Pending Payout', { cls: 'sp-card--green sp-card--click', attr: 'data-scroll-earnings' });
    h += mkCard(pendingOffers, '\uD83D\uDCE9 Pending Offers', { cls: (pendingOffers > 0 ? 'sp-card--orange ' : '') + 'sp-card--click', attr: 'data-tab="offers"' });
    h += '</div>';

    h += '<div class="sp-tabs">';
    h += tab('listings', 'My Listings');
    h += tab('new', 'Submit Item');
    h += tab('offers', 'Offers' + (state.offers.length ? ' (' + state.offers.length + ')' : ''));
    h += tab('earnings', 'Earnings');
    h += '</div>';

    if (state.activeTab === 'listings') h += renderListingsTab();
    else if (state.activeTab === 'new') {
      var pc = listings.filter(function (l) { return l.status === 'pending_review' || l.status === 'pending'; }).length;
      if (pc >= MAX_PENDING_LISTINGS) {
        h += '<div class="sp-form" style="text-align:center;padding:4rem 2rem;">';
        h += '<p style="font-size:1.6rem;color:#b91c1c;font-weight:600;">You have ' + pc + ' items pending review.</p>';
        h += '<p style="color:#666;margin-top:0.5rem;">Please wait for them to be reviewed before submitting more.</p>';
        h += '</div>';
      } else {
        h += renderFormTab();
      }
    }
    else if (state.activeTab === 'offers') h += renderOffersSection();
    else if (state.activeTab === 'earnings') h += renderEarningsTab();

    h += '</div>';
    root.innerHTML = h;
    bindDashboard();
  }

  function tab(id, label) {
    return '<button class="sp-tab' + (state.activeTab === id ? ' active' : '') + '" data-tab="' + id + '">' + label + '</button>';
  }

  /* ── Listings Tab ── */
  function renderListingsTab() {
    var listings = state.listings;
    if (!listings.length) {
      return '<div class="sp-empty"><p>You have not submitted any items yet.</p>' +
        '<button class="sp-btn sp-btn-primary" ' + (LAYOUT === 'stacked' ? 'data-open-submit' : 'data-tab="new"') + '>Submit Your First Item</button></div>';
    }
    var h = '<div class="sp-listings">';
    for (var i = 0; i < listings.length; i++) {
      var l = listings[i];
      if (state.editingListing === l.id) {
        h += renderEditForm(l);
        continue;
      }
      var photo = (l.photos || l.photo_urls || [])[0] || '';
      h += '<div class="sp-listing' + (l.status === 'paid_out' || l.status === 'withdrawn' ? ' sp-listing--paid' : '') + '">';
      h += photo
        ? '<img class="sp-listing-photo" src="' + esc(photo) + '" alt="' + esc(l.title) + '" loading="lazy" />'
        : '<div class="sp-listing-photo" style="display:flex;align-items:center;justify-content:center;color:#aaa;font-size:1.5rem;">No Photo</div>';
      h += '<div class="sp-listing-info">';
      h += '<div class="sp-listing-title">' + esc(l.title) + '</div>';
      h += '<div class="sp-listing-meta"><span>' + fmt(l.asking_price_cents) + '</span>' + mkBadge(l.status) + '</div>';
      if (l.status === 'rejected' && l.rejection_reason)
        h += '<div class="sp-listing-rejected">Rejected: ' + esc(l.rejection_reason) + '</div>';
      if (l.status === 'withdrawn' && l.withdrawal_reason)
        h += '<div class="sp-listing-rejected" style="color:#495057;">Cancelled: ' + esc(l.withdrawal_reason) + '</div>';
      h += '<div class="sp-listing-date">Submitted ' + fmtDate(l.created_at || l.submitted_at) + '</div>';
      if (l.shopify_product_handle && l.status !== 'paid_out') {
        var productUrl = SHOP_URL + '/products/' + l.shopify_product_handle;
        h += '<div class="sp-share">';
        h += '<a href="' + esc(productUrl) + '" target="_blank" class="sp-share-view">View Listing</a>';
        h += '<button class="sp-share-copy" data-copy="' + esc(productUrl) + '">Copy Link</button>';
        h += '</div>';
      }
      if (l.status === 'sold') {
        if (l.buyer_shipping_address) {
          var addr = l.buyer_shipping_address;
          h += '<div style="margin-top:0.625rem;padding:0.75rem;background:#fff3cd;border:1px solid #ffc107;border-radius:6px;font-size:1.3rem;">';
          h += '<strong style="display:block;margin-bottom:0.25rem;">Ship To:</strong>';
          h += esc(addr.name) + '<br>';
          h += esc(addr.address1);
          if (addr.address2) h += '<br>' + esc(addr.address2);
          h += '<br>' + esc(addr.city) + ', ' + esc(addr.province_code || addr.province) + ' ' + esc(addr.zip);
          if (addr.country_code && addr.country_code !== 'US') h += '<br>' + esc(addr.country);
          h += '</div>';
        }
        if (l.inbound_tracking_number) {
          h += '<div style="margin-top:0.625rem;padding:0.5rem 0.75rem;background:#d4edda;border-radius:4px;font-size:1.3rem;">';
          h += '<strong>Tracking:</strong> ' + esc(l.inbound_carrier ? l.inbound_carrier.toUpperCase() + ' ' : '') + esc(l.inbound_tracking_number);
          h += '</div>';
        } else {
          h += '<div style="margin-top:0.625rem;" id="sp-tracking-wrap-' + l.id + '">';
          h += '<button class="sp-btn sp-btn-primary" style="font-size:1.3rem;padding:0.6rem 1.2rem;" data-add-tracking="' + l.id + '">Add Shipping Tracking</button>';
          h += '</div>';
        }
      }
      if (l.status === 'pending_review') {
        h += '<button class="sp-btn sp-btn-secondary" style="font-size:1.2rem;padding:0.4rem 1rem;margin-top:0.5rem;" data-edit-listing="' + l.id + '">Edit</button>';
      } else if (l.status === 'approved' || l.status === 'live') {
        h += '<button class="sp-btn sp-btn-secondary" style="font-size:1.2rem;padding:0.4rem 1rem;margin-top:0.5rem;" data-request-edit="' + l.id + '">Request Edit</button>';
      }
      if (l.status === 'pending_review' || l.status === 'approved' || l.status === 'live') {
        h += '<button class="sp-btn" style="font-size:1.2rem;padding:0.4rem 1rem;margin-top:0.5rem;background:#fff;color:#dc3545;border:1px solid #dc3545;" data-cancel-listing="' + l.id + '">Cancel Listing</button>';
      }
      h += '</div></div>';
    }
    return h + '</div>';
  }

  function renderEditForm(l) {
    var ef = state.editFormData;
    var isReq = ef._isRequest;
    var h = '<div class="sp-listing" style="padding:1.6rem;">';
    h += '<div class="sp-form-title" style="font-size:1.6rem;margin-bottom:1rem;">' + (isReq ? 'Request Edit' : 'Edit Listing') + '</div>';
    h += '<label style="font-weight:600;font-size:1.3rem;margin-bottom:0.25rem;display:block;">Title</label>';
    h += '<input type="text" data-edit-field="title" value="' + esc(ef.title || '') + '" style="width:100%;padding:0.6rem;border:1px solid #ccc;border-radius:4px;font-size:1.3rem;box-sizing:border-box;margin-bottom:0.75rem;font-family:inherit;background:#fff;color:#222;">';
    h += '<label style="font-weight:600;font-size:1.3rem;margin-bottom:0.25rem;display:block;">Description</label>';
    h += '<textarea data-edit-field="description" style="width:100%;padding:0.6rem;border:1px solid #ccc;border-radius:4px;font-size:1.3rem;box-sizing:border-box;margin-bottom:0.75rem;min-height:80px;font-family:inherit;background:#fff;color:#222;">' + esc(ef.description || '') + '</textarea>';
    h += '<label style="font-weight:600;font-size:1.3rem;margin-bottom:0.25rem;display:block;">Price ($)</label>';
    h += '<input type="number" data-edit-field="asking_price_cents" value="' + ((ef.asking_price_cents || 0) / 100) + '" step="0.01" min="1" style="width:100%;padding:0.6rem;border:1px solid #ccc;border-radius:4px;font-size:1.3rem;box-sizing:border-box;margin-bottom:0.75rem;font-family:inherit;background:#fff;color:#222;">';
    if (isReq) {
      h += '<label style="font-weight:600;font-size:1.3rem;margin-bottom:0.25rem;display:block;">Reason for changes</label>';
      h += '<textarea data-edit-field="reason" style="width:100%;padding:0.6rem;border:1px solid #ccc;border-radius:4px;font-size:1.3rem;box-sizing:border-box;margin-bottom:0.75rem;min-height:60px;font-family:inherit;background:#fff;color:#222;" placeholder="Why do you want to make these changes?">' + esc(ef.reason || '') + '</textarea>';
    }
    h += '<div style="display:flex;gap:0.5rem;">';
    h += '<button class="sp-btn sp-btn-primary" style="font-size:1.2rem;padding:0.6rem 1.2rem;" data-save-edit>' + (isReq ? 'Submit Request' : 'Save Changes') + '</button>';
    h += '<button class="sp-btn sp-btn-secondary" style="font-size:1.2rem;padding:0.6rem 1.2rem;" data-cancel-edit>Cancel</button>';
    h += '</div></div>';
    return h;
  }

  /* ── Form Tab (6-step wizard) ── */
  function renderFormTab() {
    var steps = ['Category', 'Details', 'Pricing', 'Photos', 'Payout', 'Review'];
    var pct = Math.round((state.formStep / (steps.length - 1)) * 100);
    var h = '<div class="sp-form"><div class="sp-steps">';
    h += '<div class="sp-steps-row">';
    for (var i = 0; i < steps.length; i++) {
      var numCls = i < state.formStep ? 'done' : (i === state.formStep ? 'active' : '');
      var stepCls = i < state.formStep ? 'is-done' : (i === state.formStep ? 'is-active' : '');
      h += '<div class="sp-step ' + stepCls + '"><div class="sp-step-num ' + numCls + '">' + (i < state.formStep ? '\u2713' : (i + 1)) + '</div>';
      h += '<span class="sp-step-label">' + steps[i] + '</span></div>';
      if (i < steps.length - 1) h += '<div class="sp-step-line' + (i < state.formStep ? ' done' : '') + '"></div>';
    }
    h += '</div>';
    h += '<div class="sp-progress-bar"><div class="sp-progress-fill" style="width:' + pct + '%"></div></div>';
    h += '<div class="sp-progress-text">Step ' + (state.formStep + 1) + ' of ' + steps.length + ' \u2014 ' + steps[state.formStep] + '</div>';
    h += '</div>';
    if (state.formStep === 0) h += formStep0();
    else if (state.formStep === 1) h += formStep1();
    else if (state.formStep === 2) h += formStep2();
    else if (state.formStep === 3) h += formStep3();
    else if (state.formStep === 4) h += formStep4();
    else if (state.formStep === 5) h += formStep5();
    return h + '</div>';
  }

  function formStep0() {
    var d = state.formData;
    var h = '<div class="sp-form-title">What are you selling?</div>';
    h += '<div class="sp-form-subtitle">Choose a category that best describes your item, then tell us about its condition.</div>';
    h += '<label>Category</label><div class="sp-opt-grid">';
    CATEGORIES.forEach(function (c) {
      h += '<button class="sp-opt-btn' + (d.category === c.value ? ' selected' : '') + '" data-cat="' + c.value + '">';
      h += '<span class="sp-opt-icon">' + c.icon + '</span>';
      h += '<span>' + c.label + '</span>';
      h += '</button>';
    });
    h += '</div><label style="margin-top:2rem">Condition</label><div class="sp-opt-grid" style="grid-template-columns:repeat(4,1fr);">';
    CONDITIONS.forEach(function (c) {
      h += '<button class="sp-opt-btn' + (d.condition === c.value ? ' selected' : '') + '" data-cond="' + c.value + '">';
      h += '<span class="sp-opt-icon">' + c.icon + '</span>';
      h += '<span>' + c.label + '</span>';
      h += '<span class="sp-opt-desc">' + c.desc + '</span>';
      h += '</button>';
    });
    h += '</div><div class="sp-form-nav"><div></div>';
    if (d.category && d.condition) h += '<button class="sp-btn sp-btn-primary" data-next>Continue</button>';
    h += '</div>';
    return h;
  }

  function formStep1() {
    var d = state.formData;
    var h = '<div class="sp-form-title">Item Details</div>';
    h += '<div class="sp-form-subtitle">Describe your item so buyers know what they are getting.</div>';
    h += '<label>Title *</label><input type="text" data-field="title" value="' + esc(d.title || '') + '" placeholder="e.g. Edea Ice Fly Boots Size 245">';
    h += '<label>Description *</label><textarea data-field="description" placeholder="Describe the item, condition details, how long used, any flaws...">' + esc(d.description || '') + '</textarea>';
    h += '<label>Brand</label><input type="text" data-field="brand" value="' + esc(d.brand || '') + '" placeholder="e.g. Edea, Mondor, Jackson">';
    h += '<label>Size</label><input type="text" data-field="size" value="' + esc(d.size || '') + '" placeholder="e.g. Adult Small, 245, 6.5">';
    h += '<div class="sp-form-nav">';
    h += '<button class="sp-btn sp-btn-secondary" data-prev>Back</button>';
    h += '<button class="sp-btn sp-btn-primary" data-next>Continue</button>';
    h += '</div>';
    return h;
  }

  function formStep2() {
    var d = state.formData;
    var price = d.asking_price_cents ? (d.asking_price_cents / 100) : '';
    var h = '<div class="sp-form-title">Set Your Price</div>';
    h += '<div class="sp-form-subtitle">Enter what you want to list the item for. We take a ' + COMMISSION_PCT + '% commission + ' + PROCESSING_PCT + '% processing fee.</div>';
    h += '<div class="sp-shipping-tip" style="background:#fff3e0;border:1px solid #f0c36d;border-radius:8px;padding:12px 14px;margin-bottom:16px;font-size:14px;color:#7a4f01;line-height:1.5;"><strong>Important: Shipping is included in your listed price.</strong> Buyers see &ldquo;free shipping included&rdquo; on the product page &mdash; you ship directly to the buyer at your own expense. Most items ship for $8&ndash;15 via USPS Priority Mail. Make sure your asking price covers this!</div>';
    h += '<label>Listing Price ($) *</label><input type="number" id="sp-price-input" data-field="price" value="' + price + '" placeholder="0.00" min="1" step="0.01">';
    h += '<div id="sp-price-calc">';
    if (price) h += buildCalc(price);
    h += '</div>';
    h += '<label style="display:flex;align-items:flex-start;gap:0.75rem;cursor:pointer;margin-top:1.5rem;font-weight:400;">';
    h += '<input type="checkbox" data-accept-offers style="margin-top:0.25rem;width:20px;height:20px;flex-shrink:0;" ' + (state.formData.acceptOffers !== false ? 'checked' : '') + '>';
    h += '<span style="font-size:1.4rem;color:#1a1a1a;">Allow buyers to make offers on this item. <span style="color:#777;">If unchecked, buyers can only purchase at your listed price.</span></span>';
    h += '</label>';
    h += '<div class="sp-form-nav">';
    h += '<button class="sp-btn sp-btn-secondary" data-prev>Back</button>';
    h += '<button class="sp-btn sp-btn-primary" data-next>Continue</button>';
    h += '</div>';
    return h;
  }

  function buildCalc(price) {
    var p = parseFloat(price);
    if (!p || p <= 0) return '';
    var commission = Math.floor(p * COMMISSION_RATE * 100) / 100;
    var fee = Math.floor(p * PROCESSING_RATE * 100) / 100;
    var payout = Math.floor(p * (1 - COMMISSION_RATE) * (1 - PROCESSING_RATE) * 100) / 100;
    var c = '<div class="sp-calc">';
    c += '<div class="sp-calc-row"><span>Listing price</span><span>$' + p.toFixed(2) + '</span></div>';
    c += '<div class="sp-calc-row"><span>AST commission (' + COMMISSION_PCT + '%)</span><span>-$' + commission.toFixed(2) + '</span></div>';
    c += '<div class="sp-calc-row"><span>Processing fee (' + PROCESSING_PCT + '%)</span><span>-$' + fee.toFixed(2) + '</span></div>';
    c += '<div class="sp-calc-row total"><span>Your payout</span><span>$' + payout.toFixed(2) + '</span></div>';
    c += '</div>';
    return c;
  }

  function formStep3() {
    var h = '<div class="sp-form-title">Photos</div>';
    h += '<div class="sp-form-subtitle">Upload up to 5 photos. The first photo will be the main listing image.</div>';
    h += '<div class="sp-photos">';
    for (var i = 0; i < 5; i++) {
      if (state.photos[i]) {
        h += '<div class="sp-photo-slot"><img src="' + state.photos[i].preview + '" alt="">';
        h += '<button class="sp-photo-rm" data-remove="' + i + '">\u00d7</button></div>';
      } else {
        h += '<div class="sp-photo-slot" data-upload="' + i + '"><span class="sp-photo-add">+</span></div>';
      }
    }
    h += '</div>';
    h += '<input type="file" accept="image/jpeg,image/png,image/webp" style="display:none" id="sp-file-input">';
    h += '<p style="font-size:1.3rem;color:#777;margin-bottom:1rem">JPG, PNG, or WebP. Max 5 MB each.</p>';
    h += '<div class="sp-form-nav">';
    h += '<button class="sp-btn sp-btn-secondary" data-prev>Back</button>';
    h += '<button class="sp-btn sp-btn-primary" data-next>Continue</button>';
    h += '</div>';
    return h;
  }

  function formStep4() {
    var d = state.formData;
    var h = '<div class="sp-form-title">Payout Information</div>';
    h += '<div class="sp-form-subtitle">Tell us how you would like to be paid when your item sells.</div>';
    h += '<label>Your Name</label><input type="text" data-field="seller_name" value="' + esc(d.seller_name || '') + '" placeholder="First and last name">';
    h += '<label>Payout Method</label><select data-field="payout_method">';
    h += '<option value="paypal"' + (d.payout_method !== 'venmo' ? ' selected' : '') + '>PayPal</option>';
    h += '<option value="venmo"' + (d.payout_method === 'venmo' ? ' selected' : '') + '>Venmo</option></select>';
    h += '<label>PayPal Email or Venmo Username *</label>';
    h += '<input type="text" data-field="payout_handle" value="' + esc(d.payout_handle || '') + '" placeholder="your@email.com or @username">';
    h += '<div class="sp-form-nav">';
    h += '<button class="sp-btn sp-btn-secondary" data-prev>Back</button>';
    h += '<button class="sp-btn sp-btn-primary" data-next>Review Listing</button>';
    h += '</div>';
    return h;
  }

  function formStep5() {
    var d = state.formData;
    var price = (d.asking_price_cents || 0) / 100;
    var payout = Math.floor(price * (1 - COMMISSION_RATE) * (1 - PROCESSING_RATE) * 100) / 100;
    var catLabel = (CATEGORIES.find(function (c) { return c.value === d.category; }) || {}).label || d.category;
    var condLabel = (CONDITIONS.find(function (c) { return c.value === d.condition; }) || {}).label || d.condition;
    var h = '<div class="sp-form-title">Review Your Listing</div>';
    h += '<div class="sp-form-subtitle">Make sure everything looks correct before submitting.</div>';
    h += reviewRow('Title', d.title);
    h += reviewRow('Category', catLabel);
    h += reviewRow('Condition', condLabel);
    if (d.brand) h += reviewRow('Brand', d.brand);
    if (d.size) h += reviewRow('Size', d.size);
    h += reviewRow('Listing Price', '$' + price.toFixed(2));
    h += reviewRow('Your Payout', '$' + payout.toFixed(2));
    h += reviewRow('Accept Offers', d.acceptOffers !== false ? 'Yes' : 'No (Buy Now Only)');
    h += reviewRow('Payout Method', (d.payout_method || 'paypal').charAt(0).toUpperCase() + (d.payout_method || 'paypal').slice(1) + ': ' + esc(d.payout_handle || ''));
    if (d.seller_name) h += reviewRow('Name', d.seller_name);
    if (state.photos.filter(Boolean).length) {
      h += '<div style="margin-top:1rem"><span class="sp-review-label">Photos</span><div class="sp-review-photos">';
      state.photos.forEach(function (p) { if (p) h += '<img src="' + p.preview + '" alt="">'; });
      h += '</div></div>';
    }
    h += '<div style="margin-top:2rem;padding-top:1.5rem;border-top:1px solid #e5e5e5;">';
    h += '<div class="sp-form-title" style="font-size:1.8rem;">Terms & Conditions</div>';
    h += '<div style="max-height:250px;overflow-y:auto;border:1px solid #e5e5e5;border-radius:6px;padding:1.6rem;margin:1rem 0;font-size:1.3rem;line-height:1.6;color:#666;background:#fafafa;">';
    h += TERMS_HTML;
    h += '</div>';
    h += '<label style="display:flex;align-items:flex-start;gap:0.75rem;cursor:pointer;margin-top:1rem;font-weight:400;">';
    h += '<input type="checkbox" data-terms-check style="margin-top:0.25rem;width:20px;height:20px;flex-shrink:0;" ' + (state.formData.termsAccepted ? 'checked' : '') + '>';
    h += '<span style="font-size:1.4rem;color:#1a1a1a;">I have read and agree to the Consignment Terms and Conditions. I confirm that I am the legal owner of this item and that all information provided is accurate.</span>';
    h += '</label>';
    h += '<label style="display:flex;align-items:flex-start;gap:0.75rem;cursor:pointer;margin-top:1rem;font-weight:400;">';
    h += '<input type="checkbox" data-email-consent style="margin-top:0.25rem;width:20px;height:20px;flex-shrink:0;" ' + (state.formData.emailConsent ? 'checked' : '') + '>';
    h += '<span style="font-size:1.4rem;color:#1a1a1a;">I\'d like to receive email updates about my listings, new features, and skating gear tips from Adults Skate Too.</span>';
    h += '</label>';
    h += '<label style="display:flex;align-items:flex-start;gap:0.75rem;cursor:pointer;margin-top:1rem;font-weight:400;">';
    h += '<input type="checkbox" data-sms-consent style="margin-top:0.25rem;width:20px;height:20px;flex-shrink:0;" ' + (state.formData.smsConsent ? 'checked' : '') + '>';
    h += '<span style="font-size:1.4rem;color:#1a1a1a;">I\'d like to receive SMS/text updates about my listings and consignment sales.' + (CUSTOMER_PHONE ? '' : ' <span style="color:#777;">(Phone number required below)</span>') + '</span>';
    h += '</label>';
    if (state.formData.smsConsent && !CUSTOMER_PHONE) {
      h += '<div style="margin-top:0.75rem;margin-left:2.75rem;">';
      h += '<input type="tel" data-phone-input placeholder="(555) 123-4567" value="' + esc(state.formData.phone || '') + '" style="width:100%;max-width:280px;padding:10px 12px;border:1px solid #ccc;border-radius:6px;font-size:1.4rem;">';
      h += '</div>';
    }
    h += '</div>';
    h += '<div id="sp-submit-error"></div>';
    h += '<div class="sp-form-nav">';
    h += '<button class="sp-btn sp-btn-secondary" data-prev>Back</button>';
    h += '<button class="sp-btn sp-btn-primary" data-submit' + (state.formData.termsAccepted ? '' : ' disabled style="opacity:0.4;cursor:not-allowed;"') + '>Submit Listing</button>';
    h += '</div>';
    if (!state.formData.termsAccepted) {
      h += '<div style="text-align:right;font-size:1.3rem;color:#dc3545;margin-top:0.5rem;">You must accept the Terms & Conditions to submit.</div>';
    }
    return h;
  }

  function reviewRow(l, v) {
    return '<div class="sp-review-row"><span class="sp-review-label">' + l + '</span><span class="sp-review-value">' + esc(v) + '</span></div>';
  }

  /* ── Offers Section ── */
  function renderOffersSection() {
    var offers = state.offers;
    if (!offers.length) {
      return '<div class="sp-empty"><p>No pending offers right now.</p></div>';
    }
    var h = '<div style="background:#fff3e0;border:1px solid #f0c36d;border-radius:6px;padding:8px 12px;margin-bottom:14px;font-size:13px;color:#7a4f01;line-height:1.4;">Remember: your payout needs to cover shipping costs (~$8&ndash;15 typical via USPS)</div>';
    for (var i = 0; i < offers.length; i++) {
      var o = offers[i];
      var listing = o.listings || {};
      var listedCents = listing.asking_price_cents || 0;
      var offerCents = o.offer_price_cents || 0;
      var pct = listedCents > 0 ? Math.round(offerCents / listedCents * 100) : 0;
      var listedPayout = Math.floor(listedCents * 0.70 * (1 - 0.029));
      var offerPayout = Math.floor(offerCents * 0.70 * (1 - 0.029));
      var ago = timeAgo(o.created_at);

      h += '<div class="sp-offer-card" style="background:#fff;border:1px solid #e5e5e5;border-radius:10px;padding:20px;margin-bottom:16px;">';
      h += '<div style="font-weight:700;font-size:15px;color:#1a1a1a;margin-bottom:8px;">' + esc(listing.title || 'Item') + '</div>';

      h += '<div style="display:flex;gap:24px;flex-wrap:wrap;margin-bottom:12px;">';
      h += '<div><span style="color:#666;font-size:13px;">Listed:</span> <strong>' + fmt(listedCents) + '</strong></div>';
      h += '<div><span style="color:#666;font-size:13px;">Offer:</span> <strong style="color:#2563eb;">' + fmt(offerCents) + '</strong> <span style="color:#888;font-size:13px;">(' + pct + '%)</span></div>';
      h += '</div>';

      h += '<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:12px 14px;margin-bottom:12px;">';
      h += '<div style="font-size:13px;font-weight:600;color:#1a1a1a;margin-bottom:6px;">Your profit comparison</div>';
      h += '<div style="font-size:14px;color:#555;margin-bottom:2px;">At listed price: <strong style="color:#1a1a1a;">' + fmt(listedPayout) + '</strong> payout</div>';
      h += '<div style="font-size:14px;color:#555;">At offer price: <strong style="color:#2563eb;">' + fmt(offerPayout) + '</strong> payout</div>';
      h += '<div style="font-size:12px;color:#888;margin-top:4px;">Tip: factor in ~$8&ndash;15 shipping from your payout</div>';
      h += '</div>';

      if (o.message) {
        h += '<div style="background:#f8f8f8;border:1px solid #e0e0e0;border-radius:6px;padding:10px 12px;margin-bottom:12px;font-size:13px;color:#444;font-style:italic;">&ldquo;' + esc(o.message) + '&rdquo;</div>';
      }
      h += '<div style="font-size:13px;color:#888;margin-bottom:14px;">From: ' + esc(o.buyer_email) + (o.buyer_name ? ' (' + esc(o.buyer_name) + ')' : '') + ' &bull; ' + ago + '</div>';

      h += '<div style="display:flex;gap:10px;">';
      h += '<button class="sp-btn sp-btn-primary" style="font-size:13px;padding:8px 20px;" data-offer-respond="' + o.id + '" data-offer-decision="accept">Accept</button>';
      h += '<button class="sp-btn" style="font-size:13px;padding:8px 20px;background:#dc3545;color:#fff;border:none;border-radius:6px;cursor:pointer;" data-offer-respond="' + o.id + '" data-offer-decision="decline">Decline</button>';
      h += '</div>';
      h += '</div>';
    }
    return h;
  }

  function timeAgo(dateStr) {
    if (!dateStr) return '';
    var diff = Date.now() - new Date(dateStr).getTime();
    var mins = Math.floor(diff / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return mins + 'm ago';
    var hrs = Math.floor(mins / 60);
    if (hrs < 24) return hrs + 'h ago';
    var days = Math.floor(hrs / 24);
    return days + 'd ago';
  }

  /* ── Earnings Tab ── */
  function renderEarningsTab() {
    var payouts = state.payouts;
    var pendingTotal = payouts.filter(function (p) { return p.status === 'pending'; })
      .reduce(function (s, p) { return s + (p.seller_payout_cents || 0); }, 0);
    var completedTotal = payouts.filter(function (p) { return p.status === 'completed'; })
      .reduce(function (s, p) { return s + (p.seller_payout_cents || 0); }, 0);
    var h = '<div class="sp-cards" style="margin-bottom:2rem;grid-template-columns:repeat(2,1fr);">';
    h += mkCard(fmt(pendingTotal), 'Pending Payout');
    h += mkCard(fmt(completedTotal), 'Paid Out');
    h += '</div>';
    if (!payouts.length) return h + '<div class="sp-empty"><p>No earnings yet. Once your items sell, payouts will appear here.</p></div>';
    h += '<div class="sp-table-wrap"><table class="sp-table"><thead><tr><th>Item</th><th>Sale Price</th><th>Your Payout</th><th>Status</th></tr></thead><tbody>';
    for (var i = 0; i < payouts.length; i++) {
      var p = payouts[i];
      var title = (p.listings && p.listings.title) ? p.listings.title : 'Item';
      h += '<tr><td>' + esc(title) + '</td><td>' + fmt(p.sale_price_cents) + '</td>';
      h += '<td style="font-weight:600">' + fmt(p.seller_payout_cents) + '</td>';
      h += '<td>' + mkBadge(p.status === 'completed' ? 'paid_out' : 'pending') + '</td></tr>';
    }
    return h + '</tbody></table></div>';
  }

  /* ── Success ── */
  function renderSuccess() {
    root.innerHTML = '<div class="sp-wrap ' + widthClass + '"><div class="sp-success">' +
      '<div class="sp-success-check">\u2713</div>' +
      '<div class="sp-success-title">Listing Submitted</div>' +
      '<div class="sp-success-text">Your item has been submitted for review. We will notify you within 2\u20133 business days once it has been approved and listed.</div>' +
      '<button class="sp-btn sp-btn-primary" id="sp-back-dash">Back to Dashboard</button>' +
      '</div></div>';
    document.getElementById('sp-back-dash').addEventListener('click', function () {
      state.view = 'dashboard';
      state.activeTab = 'listings';
      state.formStep = 0;
      state.formData = {};
      state.photos = [];
      state.submitOpen = false;
      state.loading = true;
      render();
      fetchSeller(state.seller.email);
    });
  }

  /* ── Event bindings ── */
  function bindDashboard() {
    document.getElementById('sp-logout').addEventListener('click', function () {
      window.location.href = '/account/logout';
    });
    bind('[data-tab]', 'click', function () {
      var t = this.getAttribute('data-tab');
      if (t === 'new' && state.activeTab !== 'new') { state.formStep = 0; state.formData = {}; state.photos = []; }
      state.activeTab = t;
      render();
    });
    bind('[data-cat]', 'click', function () { state.formData.category = this.getAttribute('data-cat'); render(); });
    bind('[data-cond]', 'click', function () { state.formData.condition = this.getAttribute('data-cond'); render(); });
    bind('[data-scroll-earnings]', 'click', function () {
      var el = document.getElementById('sp-earnings-section');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        state.activeTab = 'earnings';
        render();
      }
    });
    bind('[data-scroll-offers]', 'click', function () {
      var el = document.getElementById('sp-offers-section');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        state.activeTab = 'offers';
        render();
      }
    });

    var priceInput = document.getElementById('sp-price-input');
    if (priceInput) {
      priceInput.addEventListener('input', function () {
        state.formData.asking_price_cents = Math.round(parseFloat(this.value) * 100) || 0;
        var calcEl = document.getElementById('sp-price-calc');
        if (calcEl) calcEl.innerHTML = buildCalc(this.value);
      });
    }

    bind('[data-field]', 'input', function () {
      var f = this.getAttribute('data-field');
      if (f === 'price') return;
      state.formData[f] = this.value;
    });
    bind('[data-field]', 'change', function () { state.formData[this.getAttribute('data-field')] = this.value; });
    bind('[data-next]', 'click', function () {
      if (validateStep()) { state.formStep++; render(); }
    });
    bind('[data-prev]', 'click', function () { state.formStep--; render(); });
    bind('[data-upload]', 'click', function () {
      window._spUploadIdx = parseInt(this.getAttribute('data-upload'));
      document.getElementById('sp-file-input').click();
    });
    var fileInput = document.getElementById('sp-file-input');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files[0];
        if (!file) return;
        if (file.size > 5 * 1024 * 1024) { alert('File too large (max 5MB)'); return; }
        var reader = new FileReader();
        reader.onload = function () {
          state.photos[window._spUploadIdx] = { file: file, preview: reader.result };
          render();
        };
        reader.readAsDataURL(file);
        fileInput.value = '';
      });
    }
    bind('[data-remove]', 'click', function (e) {
      e.stopPropagation();
      state.photos[parseInt(this.getAttribute('data-remove'))] = null;
      render();
    });
    bind('[data-terms-check]', 'change', function () { state.formData.termsAccepted = this.checked; render(); });
    bind('[data-email-consent]', 'change', function () { state.formData.emailConsent = this.checked; });
    bind('[data-sms-consent]', 'change', function () { state.formData.smsConsent = this.checked; render(); });
    bind('[data-phone-input]', 'input', function () { state.formData.phone = this.value; });
    bind('[data-accept-offers]', 'change', function () { state.formData.acceptOffers = this.checked; });
    bind('[data-submit]', 'click', function () { submitListing(this); });

    // Cancel listing
    bind('[data-cancel-listing]', 'click', function () {
      var listingId = this.getAttribute('data-cancel-listing');
      var listing = state.listings.find(function (l) { return l.id === listingId; });
      if (!listing) return;
      var msg = listing.status === 'live'
        ? 'Are you sure you want to cancel "' + listing.title + '"? This will remove it from the store and decline any pending offers.'
        : 'Are you sure you want to cancel "' + listing.title + '"? This cannot be undone.';
      if (!confirm(msg)) return;
      var btn = this;
      btn.disabled = true;
      btn.textContent = 'Cancelling...';
      fetch('/apps/consignment/api/cancel', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ listing_id: listingId, seller_email: state.seller.email })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || 'Failed to cancel'); });
        return r.json();
      }).then(function () {
        listing.status = 'withdrawn';
        state.offers = state.offers.filter(function (o) { return o.listing_id !== listingId; });
        render();
      }).catch(function (err) {
        alert(err.message);
        btn.disabled = false;
        btn.textContent = 'Cancel Listing';
      });
    });

    // Tracking
    bind('[data-add-tracking]', 'click', function () {
      var listingId = this.getAttribute('data-add-tracking');
      var wrap = document.getElementById('sp-tracking-wrap-' + listingId);
      if (!wrap) return;
      wrap.innerHTML = '<div style="margin-top:0.5rem">' +
        '<select data-tracking-carrier style="width:auto;padding:0.6rem;margin-bottom:0.5rem;font-size:1.3rem;border:1px solid #ccc;border-radius:4px;font-family:inherit;background:#fff;color:#222;">' +
        '<option value="usps">USPS</option><option value="ups">UPS</option><option value="fedex">FedEx</option><option value="other">Other</option></select>' +
        '<input type="text" data-tracking-input placeholder="Tracking number" style="width:100%;padding:0.6rem;font-size:1.3rem;border:1px solid #ccc;border-radius:4px;margin-bottom:0.5rem;box-sizing:border-box;font-family:inherit;background:#fff;color:#222;">' +
        '<button class="sp-btn sp-btn-primary" style="font-size:1.2rem;padding:0.6rem 1.2rem;" data-save-tracking="' + listingId + '">Save</button>' +
        '</div>';
      var saveBtn = wrap.querySelector('[data-save-tracking]');
      if (saveBtn) saveBtn.addEventListener('click', function () {
        var carrier = wrap.querySelector('[data-tracking-carrier]').value;
        var trackNum = wrap.querySelector('[data-tracking-input]').value.trim();
        if (!trackNum) { alert('Please enter a tracking number'); return; }
        this.disabled = true;
        this.textContent = 'Saving...';
        var btn = this;
        fetch('/apps/consignment/api/tracking', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ listing_id: listingId, tracking_number: trackNum, carrier: carrier, email: state.seller.email })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || 'Failed'); });
          return r.json();
        }).then(function () {
          var listing = state.listings.find(function (l) { return l.id === listingId; });
          if (listing) { listing.inbound_tracking_number = trackNum; listing.inbound_carrier = carrier; }
          render();
        }).catch(function (err) {
          alert(err.message);
          btn.disabled = false;
          btn.textContent = 'Save';
        });
      });
    });

    // Edit listing
    bind('[data-edit-listing]', 'click', function () {
      var listingId = this.getAttribute('data-edit-listing');
      var listing = state.listings.find(function (l) { return l.id === listingId; });
      if (!listing) return;
      state.editingListing = listingId;
      state.editFormData = { title: listing.title, description: listing.description || '', brand: listing.brand || '', size: listing.size || '', asking_price_cents: listing.asking_price_cents };
      render();
    });

    // Request edit
    bind('[data-request-edit]', 'click', function () {
      var listingId = this.getAttribute('data-request-edit');
      var listing = state.listings.find(function (l) { return l.id === listingId; });
      if (!listing) return;
      state.editingListing = listingId;
      state.editFormData = { title: listing.title, description: listing.description || '', brand: listing.brand || '', size: listing.size || '', asking_price_cents: listing.asking_price_cents, reason: '', _isRequest: true };
      render();
    });

    bind('[data-edit-field]', 'input', function () { state.editFormData[this.getAttribute('data-edit-field')] = this.value; });
    bind('[data-edit-field]', 'change', function () { state.editFormData[this.getAttribute('data-edit-field')] = this.value; });
    bind('[data-cancel-edit]', 'click', function () { state.editingListing = null; state.editFormData = {}; render(); });
    bind('[data-save-edit]', 'click', function () { submitEdit(this); });

    // Copy share link
    bind('[data-copy]', 'click', function () {
      var url = this.getAttribute('data-copy');
      var btn = this;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          btn.textContent = 'Copied!';
          btn.classList.add('copied');
          setTimeout(function () { btn.textContent = 'Copy Link'; btn.classList.remove('copied'); }, 2000);
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        btn.textContent = 'Copied!';
        btn.classList.add('copied');
        setTimeout(function () { btn.textContent = 'Copy Link'; btn.classList.remove('copied'); }, 2000);
      }
    });

    // Stacked mode: open submit wizard
    bind('[data-open-submit]', 'click', function () {
      state.submitOpen = true;
      state.formStep = 0;
      state.formData = {};
      state.photos = [];
      render();
    });

    // Stacked mode: cancel submit wizard
    bind('[data-cancel-submit]', 'click', function () {
      state.submitOpen = false;
      state.formStep = 0;
      state.formData = {};
      state.photos = [];
      render();
    });

    // Stacked mode: toggle listings collapsed
    bind('[data-toggle-listings]', 'click', function () {
      state.listingsCollapsed = !state.listingsCollapsed;
      render();
    });

    // Offer respond
    bind('[data-offer-respond]', 'click', function () {
      var offerId = this.getAttribute('data-offer-respond');
      var decision = this.getAttribute('data-offer-decision');
      var btn = this;
      var card = btn.closest('.sp-offer-card') || btn.parentElement;
      var buttons = card ? card.querySelectorAll('[data-offer-respond]') : [];
      buttons.forEach(function (b) { b.disabled = true; });
      btn.textContent = decision === 'accept' ? 'Accepting...' : 'Declining...';

      fetch('/apps/consignment/api/offer-respond', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          offer_id: offerId,
          decision: decision,
          seller_email: state.seller.email
        })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || 'Failed'); });
        return r.json();
      }).then(function () {
        // Remove from local state and re-render
        state.offers = state.offers.filter(function (o) { return o.id !== offerId; });
        if (decision === 'accept') {
          // Refresh data to get updated listing price
          fetchSeller(state.seller.email, false);
        } else {
          render();
        }
      }).catch(function (err) {
        alert(err.message);
        buttons.forEach(function (b) { b.disabled = false; });
        btn.textContent = decision === 'accept' ? 'Accept' : 'Decline';
      });
    });
  }

  /* ── Contact form binding (called from Liquid-rendered form) ── */
  function bindContactForm() {
    var form = document.getElementById('sp-contact-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameEl = form.querySelector('[name="contact_name"]');
      var emailEl = form.querySelector('[name="contact_email"]');
      var subjectEl = form.querySelector('[name="contact_subject"]');
      var messageEl = form.querySelector('[name="contact_message"]');
      var btn = form.querySelector('[type="submit"]');
      var msgDiv = document.getElementById('sp-contact-msg');
      var name = nameEl ? nameEl.value.trim() : '';
      var email = emailEl ? emailEl.value.trim() : '';
      var subject = subjectEl ? subjectEl.value : 'General Question';
      var message = messageEl ? messageEl.value.trim() : '';
      if (!name || !email || !message) {
        if (msgDiv) { msgDiv.innerHTML = '<div class="sp-error">Please fill in all required fields.</div>'; }
        return;
      }
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
      if (msgDiv) msgDiv.innerHTML = '';
      fetch('/apps/consignment/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name, email: email, subject: subject, message: message })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || 'Failed to send'); });
        return r.json();
      }).then(function () {
        form.innerHTML = '<div class="sp-contact-success"><div class="sp-contact-success-icon">\u2713</div><div class="sp-form-title">Message Sent</div><p style="color:#666;margin-top:0.5rem;font-size:1.5rem">We will get back to you within 1\u20132 business days.</p></div>';
      }).catch(function (err) {
        if (msgDiv) { msgDiv.innerHTML = '<div class="sp-error">' + esc(err.message) + '</div>'; }
        if (btn) { btn.disabled = false; btn.textContent = 'Send Message'; }
      });
    });
  }

  // Initialize contact form binding after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindContactForm);
  } else {
    bindContactForm();
  }

  /* ── Helpers ── */
  function bind(sel, evt, fn) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) els[i].addEventListener(evt, fn);
  }

  function validateStep() {
    var d = state.formData;
    var step = state.formStep;
    if (step === 0) return !!(d.category && d.condition);
    if (step === 1) {
      if (!d.title || !d.description) { alert('Please fill in the title and description.'); return false; }
      return true;
    }
    if (step === 2) {
      if (!d.asking_price_cents || d.asking_price_cents < 100) { alert('Please enter a price of at least $1.00.'); return false; }
      return true;
    }
    if (step === 3) {
      if (!state.photos.length || !state.photos.some(function (p) { return p && p.file; })) { alert('Please upload at least one photo.'); return false; }
      return true;
    }
    if (step === 4) {
      if (!d.payout_handle) { alert('Please enter your payout information.'); return false; }
      return true;
    }
    return true;
  }

  function submitEdit(btn) {
    var listingId = state.editingListing;
    if (!listingId) return;
    var ef = state.editFormData;
    var isReq = ef._isRequest;
    var changes = {};
    var listing = state.listings.find(function (l) { return l.id === listingId; });
    if (!listing) return;
    if (ef.title && ef.title !== listing.title) changes.title = ef.title;
    if (ef.description && ef.description !== (listing.description || '')) changes.description = ef.description;
    var priceEl = document.querySelector('[data-edit-field="asking_price_cents"]');
    if (priceEl) {
      var newCents = Math.round(parseFloat(priceEl.value) * 100) || 0;
      if (newCents > 0 && newCents !== listing.asking_price_cents) changes.asking_price_cents = newCents;
    }
    if (Object.keys(changes).length === 0) { alert('No changes detected.'); return; }
    btn.disabled = true;
    btn.textContent = isReq ? 'Submitting...' : 'Saving...';
    fetch('/apps/consignment/api/edit-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ listing_id: listingId, email: state.seller.email, changes: changes, reason: ef.reason || '' })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.error || 'Failed'); });
      return r.json();
    }).then(function (data) {
      if (data.type === 'direct_edit') {
        for (var k in changes) { listing[k] = changes[k]; }
        if (changes.asking_price_cents) listing.seller_payout_cents = Math.floor(changes.asking_price_cents * (1 - COMMISSION_RATE) * (1 - PROCESSING_RATE));
        alert('Changes saved!');
      } else {
        alert('Edit request submitted! The admin will review your changes.');
      }
      state.editingListing = null;
      state.editFormData = {};
      render();
    }).catch(function (err) {
      alert(err.message);
      btn.disabled = false;
      btn.textContent = isReq ? 'Submit Request' : 'Save Changes';
    });
  }

  function submitListing(btn) {
    var d = state.formData;
    var s = state.seller;
    var pendingCount = state.listings.filter(function (l) { return l.status === 'pending_review' || l.status === 'pending'; }).length;
    if (pendingCount >= MAX_PENDING_LISTINGS) {
      var errEl = document.getElementById('sp-submit-error');
      if (errEl) errEl.innerHTML = '<div class="sp-error">You have ' + pendingCount + ' items pending review. Please wait for them to be reviewed before submitting more.</div>';
      return;
    }
    if (!d.termsAccepted) {
      var errEl = document.getElementById('sp-submit-error');
      if (errEl) errEl.innerHTML = '<div class="sp-error">You must accept the Terms & Conditions to submit.</div>';
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Submitting...';
    var errEl = document.getElementById('sp-submit-error');
    if (errEl) errEl.innerHTML = '';
    var fd = new FormData();
    fd.append('shopify_customer_id', (s && s.shopify_customer_id) || '');
    fd.append('email', s ? s.email : CUSTOMER_EMAIL);
    fd.append('name', d.seller_name || (s ? s.name : '') || '');
    fd.append('title', d.title || '');
    fd.append('description', d.description || '');
    fd.append('category', d.category || '');
    fd.append('condition', d.condition || '');
    fd.append('brand', d.brand || '');
    fd.append('size', d.size || '');
    fd.append('asking_price_cents', String(d.asking_price_cents || 0));
    fd.append('payout_method', d.payout_method || 'paypal');
    fd.append('payout_handle', d.payout_handle || '');
    fd.append('terms_accepted', 'true');
    fd.append('terms_version', '2026-03-v1');
    fd.append('accept_offers', d.acceptOffers !== false ? 'true' : 'false');
    fd.append('email_consent', d.emailConsent ? 'true' : 'false');
    fd.append('sms_consent', d.smsConsent ? 'true' : 'false');
    fd.append('phone', d.phone || CUSTOMER_PHONE || '');
    state.photos.forEach(function (p, i) {
      if (p && p.file) fd.append('photo_' + i, p.file);
    });
    fetch(EDGE_URL + '/create-listing', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.message || d.error || 'Submission failed'); });
        return r.json();
      })
      .then(function () {
        state.view = 'success';
        render();
        try {
          fetch('/apps/consignment/api/notify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: s ? s.email : CUSTOMER_EMAIL,
              name: d.seller_name || (s ? s.name : '') || '',
              title: d.title || '',
              category: d.category || '',
              condition: d.condition || '',
              brand: d.brand || '',
              size: d.size || '',
              asking_price_cents: d.asking_price_cents || 0,
              shopify_customer_id: (s && s.shopify_customer_id) || '',
              email_consent: !!d.emailConsent,
              sms_consent: !!d.smsConsent,
              phone: d.phone || CUSTOMER_PHONE || '',
              customer_id: CUSTOMER_ID,
              klaviyo_list_id: KLAVIYO_LIST_ID
            })
          }).catch(function () { });
        } catch (e) { }
      })
      .catch(function (err) {
        if (errEl) errEl.innerHTML = '<div class="sp-error">' + esc(err.message) + '</div>';
        btn.disabled = false;
        btn.textContent = 'Submit Listing';
      });
  }

  function fetchSeller(email, isNewLogin) {
    fetch('/apps/consignment/api/seller?email=' + encodeURIComponent(email) + '&_t=' + Date.now())
      .then(function (r) {
        if (!r.ok) {
          if (r.status === 404 && isNewLogin) {
            state.seller = { email: email, name: CUSTOMER_NAME || '' };
            state.listings = [];
            state.payouts = [];
            state.view = 'dashboard';
            state.activeTab = 'new';
            state.loading = false;
            render();
            return null;
          }
          return r.json().then(function (d) { throw new Error(d.error || 'Not found'); });
        }
        return r.json();
      })
      .then(function (data) {
        if (!data) return;
        state.seller = data.seller;
        state.listings = data.listings || [];
        state.payouts = data.payouts || [];
        state.offers = data.offers || [];
        state.view = 'dashboard';
        state.loading = false;
        render();
      })
      .catch(function (err) {
        state.loading = false;
        state.error = err.message || 'Something went wrong. Please try again.';
        render();
      });
  }

  function mkCard(v, l, opts) {
    var cls = 'sp-card' + ((opts && opts.cls) ? ' ' + opts.cls : '');
    var attr = (opts && opts.attr) ? ' ' + opts.attr : '';
    return '<div class="' + cls + '"' + attr + '><div class="sp-card-value">' + v + '</div><div class="sp-card-label">' + l + '</div></div>';
  }
  function mkBadge(s) {
    var labels = { pending_review: '\u23F3 In Review', pending: '\u23F3 In Review', approved: '\u2705 Approved', live: '\u2728 Active', sold: '\uD83C\uDF89 Sold', paid_out: '\uD83D\uDCB0 Paid', rejected: '\u274C Rejected', withdrawn: '\u23F9 Cancelled' };
    var label = labels[s] || s || 'Pending';
    return '<span class="sp-badge sp-badge-' + (s || 'pending') + '">' + label + '</span>';
  }
  function fmt(c) { return typeof c !== 'number' ? '$0.00' : '$' + (c / 100).toFixed(2); }
  function fmtDate(d) { return d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''; }
  function esc(s) { if (!s) return ''; var d = document.createElement('div'); d.appendChild(document.createTextNode(String(s))); return d.innerHTML; }
})();
